module.exports = __webpack_public_path__ + "41d3817df7504d68e2c34cb7b52ef9a8.svg";